module.exports = __webpack_public_path__ + "static/media/included.80805204.svg";